const wowApp = require('angular').module('wowApp.shop');

//Service

//Directive
wowApp.directive('wowCopyright', ['$sce', 'SettingsService', require('./copyright-directive')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/copyright/index.js
 **/